import { requireFormattedTextFieldValue } from '../../../../misc/textFieldFormatter';

// Final defense for every GraphQL String field. Normal form/workbook ingress is
// formatted before UI validation; this guard ensures a missed object can never
// be implicitly stringified at serialization time.
export default (value) =>
  requireFormattedTextFieldValue(value)
    .replace(/["']/g, '\\"')
    .replace(/\r?\n|\r/g, ' ')
    .replace('\r', ' ');
